import React from 'react'
import Gallery from '../components/Gallery'
import _ from 'underscore';
import { Container, Header, Image, Divider, Input, Pagination } from 'semantic-ui-react'
import course from './assets/course.jpg'
import { toSlug, slash, thumbnailPath } from '../utils/utils'
import Helmet from 'react-helmet'
import majorImage from './assets/academic-major.jpg'


export default class Courses extends React.Component  {

  state = { activePage: 1, searchKey: '' }

  handleInputChange = (e, { value }) => {
    this.setState({ searchKey: value });
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
  }

  handleInputRemove = (e) => {
    const { searchKey } = this.state;
    if(searchKey !== '') {
      this.setState({ searchKey: ''});
    }
  }

  render() {

    const propsToData = (props) => {
      return props.data.allContent.edges.map(({node}) => {
        return {
          image: thumbnailPath(node.title),
          title: node.title,
          path: slash(toSlug(node.title))
        }
      })
    }

    const { activePage, searchKey } = this.state
    const icon = searchKey !== '' ? 'remove' : 'search';
    const courses =  propsToData(this.props);
    const itemPerPage = 10;
    const totalPages = Math.floor(courses.length / itemPerPage);
    const from = (activePage - 1) * itemPerPage;
    const to = activePage * itemPerPage;
    const pageTitle = "CHOOSE RIGHT COURSE TO TO DEVELOP YOUR FUTURE! | Uni Village Education";
    const description = "We provide more than 100 courses information. Find your right course right now!";
    const data = courses
      .slice(from , to)
      .filter(({ title }) => {
        const key = searchKey.toLowerCase();
        return title.toLowerCase().indexOf(key) !== -1;
      })

    return (
      <Container textAlign='center'>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={description} />
      </Helmet>
      {courses.map(({path, title}) => {
        return <a style={{display:'none'}} href={path}>{title}</a>
      })}

      <Header as='h3' icon>
        <Image src={course} />
        ACADEMIC MAJOR
        <Header.Subheader>Explore The Road To Wisdom For Better Tomorrow</Header.Subheader>
      </Header>
      <Image src={majorImage}  fluid />
      <Divider hidden />
      <Input size='small' value={searchKey} icon={icon} placeholder='Search a major name'
        fluid onChange={this.handleInputChange}
        onClick={this.handleInputRemove} />
        { searchKey === '' && <Header size='small' textAlign='left'>{from +1 } of {courses.length} results</Header>}
        { searchKey !== '' && <Header size='small' textAlign='left'>{data.length} results</Header>}
      <Divider hidden />
      <Gallery data={data} />
      <Divider hidden />
      { searchKey === '' && <Pagination firstItem={null} lastItem={null} activePage={activePage}
        onPageChange={this.handlePaginationChange} totalPages={totalPages} /> }
      <Divider hidden />
      </Container>

    )
  }
}

export const pageQuery = graphql`
query title {
  allContent: allContentfulCourse {
    edges {
      node {
        title
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/pages/courses.js